import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardCheck } from 'lucide-react';
import { CheckoutViewModal } from '../../checkout-view';
import './FechamentoPage.css';

const FechamentoPage = () => {
  const navigate = useNavigate();

  return (
    <div className="fechamento-root">
      <header className="fechamento-header">
        <nav className="fechamento-breadcrumb" aria-label="Localização em fechamento">
          <span className="fechamento-breadcrumb-avatar" aria-hidden="true">F</span>
          <span className="fechamento-breadcrumb-segment fechamento-breadcrumb-segment--parent">
            ...
          </span>
          <span className="fechamento-breadcrumb-sep" aria-hidden="true">/</span>
          <span className="fechamento-breadcrumb-current" aria-current="page">
            <ClipboardCheck size={13} strokeWidth={1.75} aria-hidden className="fechamento-breadcrumb-current-icon" />
            <span className="fechamento-breadcrumb-current-text">Fechamento</span>
          </span>
        </nav>
      </header>
      <CheckoutViewModal
        asPage
        isOpen
        onClose={() => navigate('/')}
      />
    </div>
  );
};

export default FechamentoPage;
